import { useEffect, useRef } from "react"
import styled from "styled-components"
import gsap from "gsap"
import BackButton from "@common/ui/BackButton"
import { useStore } from "@state/store"
import { useProjectDataStore } from "@state/projectDataStore"
import FloorplanSection from "./FloorplanSection"
import ViewSection from "../ViewSection"
import TextButton from "@common/ui/TextButton"
import { HeartFilledIcon, HeartIcon } from "@radix-ui/react-icons"
import { useFavoritesStore } from "@state/favouritesStore"
import Specification from "../Specification"

const ResidencePopup = ({ selectedUnit }) => {
  const wrapperRef = useRef()
  const { addToFavorites, isFavorite } = useFavoritesStore()
  const { imageOverlay, contentControls, syncState } = useStore((s) => ({
    syncState: s.syncState,
    imageOverlay: s.imageOverlay,
    contentControls: s.contentControls,
  }))
  const residencePopup = useStore((s) => s.residencePopup)
  const { brandingData } = useProjectDataStore((s) => ({
    brandingData: s.brandingData,
  }))
  let viewID
  if (selectedUnit) viewID = selectedUnit[0]?.viewID

  isFavorite(selectedUnit?.[0])
  return (
    <Wrapper
      className="residences-popup"
      bgImage={brandingData?.bgImage?.publicURL}
    >
      <BackButton
        onClick={() => {
          if (imageOverlay) {
            syncState({
              imageOverlay: false,
            })
          } else {
            syncState({
              controlsVisible: true,
              residencePopup: false,
              categoriesVisible: false,
              contentControls: { ...contentControls, index: 0 },
            })
          }
        }}
      />
      <FloorplanSection selectedUnit={selectedUnit} />
      <Specification selectedUnit={selectedUnit} />
      <TextButton
        onClick={() => addToFavorites(selectedUnit?.[0])}
        className="addToFavorites"
        icon={
          isFavorite(selectedUnit?.[0]) ? <HeartFilledIcon /> : <HeartIcon />
        }
        iconPosition="right"
        color="secondary"
        style={{ padding: "0.75rem 2rem" }}
      >
        ADD TO FAVOURITES
      </TextButton>
    </Wrapper>
  )
}

export default ResidencePopup

const Wrapper = styled.div<{ bgImage }>`
  position: fixed;
  top: 0;
  left: 15%;
  width: 85%;
  height: 100%;
  display: flex;
  background-color: var(--secondary);
  z-index: 10000;
`
